/**
 * Performs a case-insensitive search to check if the `searchTerm` exists within `textToSearch`.
 */
export default function searchIgnoreCase(textToSearch: string, searchTerm: string): boolean {
  const normalisedText = textToSearch.toLowerCase();
  const normalisedSearchTerm = searchTerm.trim().toLowerCase();

  return normalisedText.includes(normalisedSearchTerm);
}
